import { inject, InjectionToken } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';

interface HubSpotCallsToActions {
  refresh: () => void;
}

export interface HubSpotWindow extends Window {
  _hsq: unknown[];
  HubSpotCallsToActions: HubSpotCallsToActions;
}

export const HS_WINDOW = new InjectionToken<HubSpotWindow>('[HS_WINDOW]', {
  factory: () => {
    const w = inject(WA_WINDOW);

    // SAFETY(legacy): unreviewed, pre-dates this rule.
    return w as HubSpotWindow;
  },
});
